import React, { FC, ReactNode, useEffect, useState } from "react";
import "./CustomCard.scss";
import LeopartLoader from "../LeopartLoader/LeopartLoader";
import { objectToClassString } from "../../utils/functions";

type TextStyle = `${"regular" | "medium" | "bold"}-${
  | "12"
  | "14"
  | "16"
  | "20"
  | "24"
  | "32"
  | "40"}`;
interface ICustomCard {
  children?: ReactNode;
  title?: string;
  isLoading?: boolean;
  description?: string;
  styleTitle?: TextStyle;
  classNameBody?: string;
  className?: string;
  styleDescription?: TextStyle;
}

const CustomCard: FC<ICustomCard> = ({
  children,
  title,
  description,
  styleTitle = "bold-20",
  isLoading = false,
  classNameBody = "",
  className = "",
  styleDescription = "regular-16",
}) => {
  const [visibleLoading, setVisibleLoading] = useState(isLoading);

  useEffect(() => {
    isLoading && setVisibleLoading(true);
  }, [isLoading]);

  const renderHeader = () => {
    return (
      <>
        <p className={`pb-2 text-${styleTitle}`}>{title}</p>
        {description && (
          <p className={`text-${styleDescription}`}>{description}</p>
        )}
      </>
    );
  };

  return (
    <div className={`container__custom__card ${className}`}>
      {visibleLoading && (
        <div
          onTransitionEnd={(event) => {
            !isLoading && setVisibleLoading(false);
          }}
          className={`container__loader__custom__card ${objectToClassString({
            active: isLoading,
          })}`}
        >
          <LeopartLoader />
        </div>
      )}
      {title && renderHeader()}
      <div className={`w-100 h-100 ${classNameBody}`}>{children}</div>
    </div>
  );
};

export default CustomCard;
